import { useState } from "react";
import { createRoot } from "react-dom/client";
import "../login.css";

const LoginPage = () => {
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setLoading(true);
		setError("");

		const res = await fetch("/api/login", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ password }),
		});

		if (res.ok) {
			window.location.href = "/";
			return;
		}

		setError("Invalid password");
		setLoading(false);
	};

	return (
		<div className="min-h-screen bg-gray-100 flex items-center justify-center">
			<div className="bg-white p-8 rounded-lg shadow-md w-full max-w-sm">
				<h1 className="text-2xl font-bold text-gray-800 mb-6 text-center">
					Auth
				</h1>

				<form onSubmit={handleSubmit}>
					<input
						type="password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						placeholder="Enter password"
						className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
						autoFocus
					/>

					{error && (
						<p className="text-red-500 text-sm mb-4">{error}</p>
					)}

					<button
						type="submit"
						disabled={loading}
						className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50"
					>
						{loading ? "..." : "Login"}
					</button>
				</form>
			</div>
		</div>
	);
};

const root = createRoot(document.getElementById("root")!);
root.render(<LoginPage />);
